export default __webpack_public_path__ + "static/media/1207.3f165882.png";